import {
  Box,
  HStack,
  Heading,
  Text,
  Stack,
  OrderedList,
  ListItem,
} from "@chakra-ui/react";
import { StaticImageData } from "next/image";
import {
  useSectionHeadingVariant,
  useTextVariants,
} from "@/theme/components/useSectionHeading";

type Props = {
  image: StaticImageData;
  title: string;
  desc: string;
  steps: { label: string; text: React.ReactNode }[];
};

const PlainTextFrame = (props: Props) => {
  const { title, desc, steps } = props;
  const HeadingVariant = useSectionHeadingVariant();
  const TextVariant = useTextVariants();
  return (
    <Box>
      <Stack spacing={4}>
        <HStack spacing={2}>
          <Heading variant={HeadingVariant}>{title}</Heading>
        </HStack>
        <Text variant={TextVariant} color="text.100">
          {desc}
        </Text>
        <OrderedList spacing={2}>
          {steps.map((item, index) => {
            const { label, text } = item;
            return (
              <ListItem key={index}>
                <Text as="span" variant={TextVariant} fontWeight={700}>
                  {label} :{" "}
                </Text>
                {typeof text === "string" ? (
                  <Text as="span" variant={TextVariant} color="text.100">
                    {text}
                  </Text>
                ) : (
                  text
                )}
              </ListItem>
            );
          })}
        </OrderedList>
      </Stack>
    </Box>
  );
};

export default PlainTextFrame;
